var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconOptionsColumsGray(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MdTune"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.5 8.5V9.5H4.5V8.5H1.5ZM1.5 2.5V3.5H6.5V2.5H1.5ZM6.5 10.5V9.5H10.5V8.5H6.5V7.5H5.5V10.5H6.5ZM3.5 4.5V5.5H1.5V6.5H3.5V7.5H4.5V4.5H3.5ZM10.5 6.5V5.5H5.5V6.5H10.5ZM7.5 4.5H8.5V3.5H10.5V2.5H8.5V1.5H7.5V4.5Z",
    fill: "#616161"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptionsColumsGray);
export default __webpack_public_path__ + "static/media/icon_options_colums_gray.c1f1bcf95be2368c160c7d1dcf81dfcb.svg";
export { ForwardRef as ReactComponent };